// Define default options for large operations
export default {};
